module.exports = __webpack_public_path__ + "fonts/MabryPro-Bold.63c6baac.woff2";